import { gql } from 'apollo-angular';

export const permissionsFields = `
  whitelabelCustomerPortal
  consumptionDataVisualization
  internalTicketing
  payment
  chatbot
`;

export const residentAppSettingsFields = `
  ticketingVersion
  consumptionDataVersion
  documentSortingSupported
  showStartPageBanner
  startPageBannerHeadline
  startPageBannerText
  showFaqCard
  faqCardHeadline
  faqCardText

`;

const ticketSettingsFields = `
  damageTicketingType
  concernTicketingType
  allowContractlessTicketCreationForDamages
  allowContractlessTicketCreationForOtherConcerns
  allowedDamageTicketAttachmentFileTypes
  allowedConcernTicketAttachmentFileTypes
  enableTicketMessengerForDamages
  enableTicketMessengerForConcerns
  damageMessagesReadOnly
  concernMessagesReadOnly
`;

export const getPermissionsQuery = gql`
  query getAppPermissions {
    getCustomerAppPermissions {
      bookedModulesResponseBean {
        ${permissionsFields}
      }
      residentAppSettings {
        ${residentAppSettingsFields}
      }
      ticketSettings {
        ${ticketSettingsFields}
      }
    }
  }
`;
